import React, { useState } from "react";
import { ArrowLeft, ArrowRight, Plus } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import AddNewVoucher from "../CustomerModule/Addnewvoucher";
import AddExistingVoucher from "../CustomerModule/ViewVoucher";

const AddVoucher = () => {
  const [addpack, setaddpack] = useState(true);
  const navigate = useNavigate();

  return (
    <div className="mt-[3vh]">
      <div className=" bg-white ml-[2.083333vw]  mr-[2.638888vw] h-[84vh] overflow-y-scroll no-scrollbar">
        <div className="flex flex-col box-border w-[100]">
          <div className="w-[60%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[3.0375235vh] font-medium font-outfit mt-[3.51vh]">
            <div onClick={() => navigate(-1)}>
              <ArrowLeft size={20} className=" cursor-pointer" />
            </div>
            <span className="mx-4">Add Voucher</span>
          </div>
        </div>

        <div className="flex flex-row mt-10 items-start justify-start gap-x-3 ml-[3.92222vw]">
          <button
            className={`${
              addpack === true
                ? "border-[2px] border-[#5652B0] bg-[#EAD8FC]"
                : "border-[1px] border-[#acacac]"
            } rounded-lg px-3 py-2 text-[2.2003745vh] font-medium font-outfit flex items-center justify-center flex-row1`}
            onClick={() => setaddpack(true)}>
            {" "}
            <Plus color="#333333" />{" "}
            <span className="px-2 text-[#333333]">Add New Voucher</span>
          </button>
          <button
            className={`${
              addpack === false
                ? "border-[2px] border-[#5652B0] bg-[#EAD8FC]"
                : "border-[1px] border-[#acacac]"
            } rounded-lg px-3 py-2 text-[2.2003745vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row `}
            onClick={() => setaddpack(false)}>
            {" "}
            <span className="px-2 text-black">Add From Exiting Voucher</span>
          </button>
        </div>

        {addpack === false ? (
          <AddExistingVoucher />
        ) : (
          <>
            <AddNewVoucher />
          </>
        )}
      </div>
    </div>
  );
};

export default AddVoucher;
